import { common } from '@mui/material/colors';
import { alpha, PaletteOptions } from '@mui/material/styles';
import {
    contrastBackground,
    error,
    starjackPrimary,
    info,
    neutral,
    starjackSecondary,
    success,
    warning,
} from './colors';
import { grey } from '@mui/material/colors';

export function createPalette(): PaletteOptions {
    return {
        action: {
            active: neutral[500],
            disabled: alpha(neutral[900], 0.38),
            disabledBackground: alpha(neutral[900], 0.12),
            focus: alpha(neutral[900], 0.16),
            hover: alpha(neutral[900], 0.04),
            selected: alpha(neutral[900], 0.12),
        },
        background: {
            default: grey[50],
            paper: common.white,
            contrastBackground,
        },

        divider: '#d5d9df',
        error,
        info,
        mode: 'light',
        neutral,
        primary: starjackPrimary,
        secondary: starjackSecondary,
        success,
        text: {
            primary: neutral[900],
            secondary: neutral[500],
            disabled: alpha(neutral[900], 0.38),
        },
        warning,

        // legacy
        grey,
    };
}
